import { render, staticRenderFns } from "./capital_adm.vue?vue&type=template&id=01d80798&scoped=true&"
import script from "./capital_adm.vue?vue&type=script&lang=js&"
export * from "./capital_adm.vue?vue&type=script&lang=js&"
import style0 from "./capital_adm.vue?vue&type=style&index=0&id=01d80798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d80798",
  null
  
)

export default component.exports